import Dialog from "~/ui-rtk/components/ui/common/Dialog"
import { Button } from "~/ui-rtk/components/ui/controls"
import { Chip } from "~/ui-rtk/components/ui/common"
import type { TAdsetAuditRow } from "./connect"

type Props = {
  isOpen: boolean
  onClose: () => void
  onConfirm: () => void
  isLoading: boolean
  rows: TAdsetAuditRow[]
}

export default function ApplyExclusionsModal({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  rows,
}: Props) {
  const totalExclusions = rows.reduce(
    (sum, r) => sum + r.missingExclusions.length,
    0,
  )

  return (
    <Dialog isOpen={isOpen} handleClose={onClose} width={560}>
      <div className="bg-basic-dark-blue border border-basic-blue rounded-lg p-6 text-left">
        <h3 className="text-lg font-semibold text-basic-white mb-2">
          Apply Exclusions
        </h3>
        <p className="text-sm text-cadet-blue mb-4">
          Add {totalExclusions} exclusion{totalExclusions !== 1 ? "s" : ""} to{" "}
          {rows.length} adset{rows.length !== 1 ? "s" : ""}
        </p>

        <div className="max-h-72 overflow-y-auto space-y-3 mb-6">
          {rows.map(row => (
            <div
              key={row.adsetId}
              className="bg-system-blue-800 rounded-lg p-3"
            >
              <div className="text-sm font-medium text-basic-white">
                {row.adsetName}
              </div>
              <div className="text-xs text-cadet-blue mt-0.5">
                {row.campaignName}
              </div>
              <div className="flex flex-wrap gap-1 mt-2">
                {row.missingExclusions.map(a => (
                  <Chip
                    key={a.id}
                    className="bg-red-600/20 text-red-400 text-xs"
                  >
                    {a.name}
                  </Chip>
                ))}
              </div>
            </div>
          ))}
        </div>

        <div className="flex justify-end gap-3">
          <Button
            variant={{ variant: "outlined" }}
            size="sm"
            onClick={onClose}
            disabled={isLoading}
          >
            Cancel
          </Button>
          <Button
            variant={{ variant: "solid", color: "pink" }}
            size="sm"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <span className="loading loading-spinner loading-sm" />
            ) : (
              "Apply"
            )}
          </Button>
        </div>
      </div>
    </Dialog>
  )
}
